import { Outlet } from "react-router-dom";
import { Banner, CompanySwitcher, MainArea, Notification } from "../..";
import AppShell from "../../carbon/AppShell/AppShell";
import AppShellNav from "../../carbon/AppShell/AppShellNav";
import HeaderUserActions from "../../carbon/HeaderUserActions/HeaderUserActions";
import ScreenAssistant from "../../ScreenAssistant/ScreenAssistant";
import {
  buyerNavigation,
  isBuyerNavItemVisible,
  secondaryNavigation,
  sellerNavigation,
  pendingApprovalNavigation,
  isScreenAssistantEnabled,
} from "../../../utils";
import { useAuth, useBanner, useNotification, useUser } from "../../../context";

const Layout = () => {
  const {
    user,
    isBuy,
    isNew,
    isSeller,
    isPending,
    can,
    purchaseOrderModuleEnabled,
    isResetPassword,
    isPendingAdminApproval,
    isPendingRegistration,
  } = useUser();
  const { isLoading } = useAuth();
  const { isOpen, message, type, closeNotification } = useNotification();
  const { isOpen: isOpenBanner, message: bannerMessage } = useBanner();

  if (isOpen) {
    setTimeout(() => {
      closeNotification();
    }, 4000);
  }

  let isTheNavigation;
  if (isBuy) {
    isTheNavigation = buyerNavigation.filter((i) =>
      isBuyerNavItemVisible(i, { can, purchaseOrderModuleEnabled })
    );
  } else if (isSeller) {
    if (isPendingAdminApproval) {
      isTheNavigation = pendingApprovalNavigation;
    } else {
      isTheNavigation = sellerNavigation.filter(
        (i) => !i.ability || can(i.ability)
      );
    }
  }

  const showAssistant =
    isScreenAssistantEnabled() &&
    !isLoading &&
    Boolean(user) &&
    !isPendingRegistration &&
    (isBuy || (isSeller && !isPendingAdminApproval));

  const navigation =
    !isLoading && user && isTheNavigation ? (
      <AppShellNav
        navigation={isTheNavigation}
        secondary={secondaryNavigation}
      />
    ) : null;

  return (
    <AppShell
      nav={navigation}
      globalActions={
        <>
          {isBuy && <CompanySwitcher />}
          <HeaderUserActions />
        </>
      }
    >
      {isOpen ? (
        <Notification
          show={isOpen}
          handleShow={() => closeNotification()}
          message={message}
          type={type}
        />
      ) : null}
      <MainArea>
        {(isOpenBanner || isNew || isPending) && isSeller ? (
          <Banner
            isNew={isNew}
            isPending={isPending}
            bannerMessage={bannerMessage}
            isResetPassword={isResetPassword}
          />
        ) : null}
        {isResetPassword && isBuy ? (
          <Banner
            bannerMessage={bannerMessage}
            isResetPassword={isResetPassword}
          />
        ) : null}
        <div className="p-4">
          <Outlet />
        </div>
      </MainArea>
      {showAssistant && <ScreenAssistant />}
    </AppShell>
  );
};

export default Layout;
